import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.WebApi.Mitgliedschaft.MitgliedschaftPdfBestaetigungV2
 * Klasse zur Generierung des PDF der Bestätigungsseite mit Mailtexten und weiteren Attachments
 * Endpoints: /api/v2/mitgliedschaft/mailbestaetigung
 */
export class MitgliedschaftPdfBestaetigungV2Api extends BaseApiModel {
	constructor(initialProperties?: Partial<MitgliedschaftPdfBestaetigungV2Api>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected userMailText: string;
	/**
	 * Description: Text der Mail an den User
	 * APIL Type: string
	 */
	get UserMailText(): string {
		return this.userMailText;
	}

	/**
	 * Description: Text der Mail an den User
	 * APIL Type: string
	 */
	set UserMailText(value: string) {
		this.userMailText = value;
	}

	protected attachmentsExt: string;
	/**
	 * Description: Liste von IDs der PDFs welche als weitere Attachment einzeln an das Usermail gehängt werden
	 * APIL Type: string
	 */
	get AttachmentsExt(): string {
		return this.attachmentsExt;
	}

	/**
	 * Description: Liste von IDs der PDFs welche als weitere Attachment einzeln an das Usermail gehängt werden
	 * APIL Type: string
	 */
	set AttachmentsExt(value: string) {
		this.attachmentsExt = value;
	}

	protected processId: number;
	/**
	 * Description: Vorgangsnummer
	 * APIL Type: int64
	 */
	get ProcessId(): number {
		return this.processId;
	}

	/**
	 * Description: Vorgangsnummer
	 * APIL Type: int64
	 */
	set ProcessId(value: number) {
		this.processId = value;
	}

	protected htmlFragmentMitglied: string;
	/**
	 * Description: Html Fragment das ins Pdf gerendert werden soll, welches an den Kunden versendet wird
	 * APIL Type: string
	 */
	get HtmlFragmentMitglied(): string {
		return this.htmlFragmentMitglied;
	}

	/**
	 * Description: Html Fragment das ins Pdf gerendert werden soll, welches an den Kunden versendet wird
	 * APIL Type: string
	 */
	set HtmlFragmentMitglied(value: string) {
		this.htmlFragmentMitglied = value;
	}

	protected email: string;
	/**
	 * Description: Email an welche die Police gesendet wird
	 * APIL Type: string
	 */
	get Email(): string {
		return this.email;
	}

	/**
	 * Description: Email an welche die Police gesendet wird
	 * APIL Type: string
	 */
	set Email(value: string) {
		this.email = value;
	}

	protected attachments: string;
	/**
	 * Description: Liste von  IDs der PDFs welche als Attachment an das Usermail gehängt werden
	 * APIL Type: string
	 */
	get Attachments(): string {
		return this.attachments;
	}

	/**
	 * Description: Liste von  IDs der PDFs welche als Attachment an das Usermail gehängt werden
	 * APIL Type: string
	 */
	set Attachments(value: string) {
		this.attachments = value;
	}

	protected mglToken: string;
	/**
	 * Description: Token der vorausgegangenen Mitgliedschaftsanlage.
	 * APIL Type: string
	 */
	get MglToken(): string {
		return this.mglToken;
	}

	/**
	 * Description: Token der vorausgegangenen Mitgliedschaftsanlage.
	 * APIL Type: string
	 */
	set MglToken(value: string) {
		this.mglToken = value;
	}

	protected htmlFragment: string;
	/**
	 * Description: Html Fragment das ins Pdf gerendert werden soll
	 * APIL Type: string
	 */
	get HtmlFragment(): string {
		return this.htmlFragment;
	}

	/**
	 * Description: Html Fragment das ins Pdf gerendert werden soll
	 * APIL Type: string
	 */
	set HtmlFragment(value: string) {
		this.htmlFragment = value;
	}

	protected isBodyHtml: boolean;
	/**
	 * Description: Body der Email ist im Html Format
	 * APIL Type: boolean
	 */
	get IsBodyHtml(): boolean {
		return this.isBodyHtml;
	}

	/**
	 * Description: Body der Email ist im Html Format
	 * APIL Type: boolean
	 */
	set IsBodyHtml(value: boolean) {
		this.isBodyHtml = value;
	}

	protected mailBodyHtml: string;
	/**
	 * Description: Mail Body als HTML
	 * APIL Type: string
	 */
	get MailBodyHtml(): string {
		return this.mailBodyHtml;
	}

	/**
	 * Description: Mail Body als HTML
	 * APIL Type: string
	 */
	set MailBodyHtml(value: string) {
		this.mailBodyHtml = value;
	}

	protected subject: string;
	/**
	 * Description: Mail Subject
	 * APIL Type: string
	 */
	get Subject(): string {
		return this.subject;
	}

	/**
	 * Description: Mail Subject
	 * APIL Type: string
	 */
	set Subject(value: string) {
		this.subject = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): MitgliedschaftPdfBestaetigungV2Api {
		return AppUtils.Helper.createFromMap(dataObject, MitgliedschaftPdfBestaetigungV2Api, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.UserMailText = this.userMailText;
		result.AttachmentsExt = this.attachmentsExt;
		result.ProcessId = this.processId;
		result.HtmlFragmentMitglied = this.htmlFragmentMitglied;
		result.Email = this.email;
		result.Attachments = this.attachments;
		result.MglToken = this.mglToken;
		result.HtmlFragment = this.htmlFragment;
		result.IsBodyHtml = this.isBodyHtml;
		result.MailBodyHtml = this.mailBodyHtml;
		result.Subject = this.subject;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}